// extracted by extract-css-chunks-webpack-plugin
module.exports = {"image":"image_27eFT"};